import React from "react"
import $ from "jquery"
import { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"

import {
  Badge,
  Button,
  Card,
  Navbar,
  Nav,
  Table,
  Container,
  Row,
  Col,
} from "react-bootstrap"

function Tools() {
  const history = useHistory()

  const redirectToUrl = async (e) => {
    console.log($(e.target).data("url"))
  }

  useEffect(() => {
    $(document).ready(function () {
      $(".button-card").click(function () {
        var url = $(this).data("url")
        history.push(url)
      })
    })
  }, [])

  return (
    <>
      <style></style>
      <Row>
        <Col md='3'>
          <div
            className='button-card bc-purple'
            data-url='/admin/app/invoice-to-excel'
          >
            <h4>Invoice to Excel</h4>
            <p>This tool is use for converting invoice to an excel template.</p>
          </div>
        </Col>
        <Col md='3'>
          <div
            className='button-card bc-red'
            data-url='/admin/app/invoice-to-p44'
          >
            <h4>Invoice to P44 Excel</h4>
            <p>
              This tool is use for converting invoices to P44 excel template.
            </p>
          </div>
        </Col>

        <Col md='3'>
          <div
            className='button-card bc-green'
            data-url='/admin/app/signature-generator'
          >
            <h4>Signature Generator</h4>
            <p>Create responsive signature for your email here.</p>
          </div>
        </Col>

      </Row>
    </>
  )
}

export default Tools
